import Cookies from "js-cookie"
import { call, put, select } from "redux-saga/effects"

import api from "apis"
import { setWishList } from "app-store-v2/wishlist/actions"
import { updateCollectionWishlist } from "areas/collection/store/actions"

export default function* fetchWishList(action) {
  const state = yield select()

  // Prevent wishlist fetching on every hover - fetches only if forced to, wishlist object is empty or on product page
  if (
    action.forceFetch ||
    !state.wishlist.line_items ||
    state.router.location.pathname.includes("products")
  ) {
    yield doFetch(action)
    return
  }
}

function* doFetch(action) {
  const wishlistToken = Cookies.get(sl.config.cookies_config.wishlist_token)

  if (!wishlistToken) {
    return
  }

  let url = `/api/v10/wishlist/${wishlistToken}`
  const result = yield call(api.get, url)

  if (!result) {
    return
  }

  yield put(setWishList(result.data))

  // Updates the collection wishlist items when a user re-logins
  if (action.forceFetch) {
    yield put(updateCollectionWishlist(result.data.line_items))
  }
}
